import { useMemo } from 'react';
import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';

type FaxSearchFilters = {
  tags: string[];
  faxNumbers: string[];
  startDate: string;
  endDate: string;
  direction: string;
  isRead: string;
  isDelivered: string;
};

interface FaxSearchFilterStatusProps {
  filters: FaxSearchFilters;
}

export const FaxSearchFilterStatus = ({ filters }: FaxSearchFilterStatusProps) => {
  const { t } = useTranslation('fax');

  const filterDetails = useMemo(() => {
    const details: string[] = [];

    // Tags filter
    if (filters.tags && filters.tags.length > 0) {
      const count = filters.tags.length;
      details.push(count === 1 ? t('1 tag') : t('{{count}} tags', { count }));
    }

    // Read status filter
    if (filters.isRead) {
      details.push(t('read status'));
    }

    // Delivery status filter
    if (filters.isDelivered) {
      details.push(t('delivery status'));
    }

    // Direction filter
    if (filters.direction) {
      details.push(t('relay status'));
    }

    // Fax numbers filter
    if (filters.faxNumbers && filters.faxNumbers.length > 0) {
      const count = filters.faxNumbers.length;
      details.push(count === 1 ? t('1 fax number') : t('{{count}} fax numbers', { count }));
    }

    // Send date filter
    if ((filters.startDate && filters.startDate.trim() !== '') || (filters.endDate && filters.endDate.trim() !== '')) {
      details.push(t('send date'));
    }

    return details;
  }, [filters]);

  if (filterDetails.length === 0) {
    return null;
  }

  const filterText = filterDetails.join(', ');

  return (
    <Text size='small' color='primary'>
      {filterText}
    </Text>
  );
};
